import { FC, InputHTMLAttributes } from 'react'
import { Group, FormInputLabel, Input } from './FormInput.style'

type FormInputProps = { label: string } & InputHTMLAttributes<HTMLInputElement>

const FormInput: FC<FormInputProps> = ({ label, ...otherProps }) => {
  return (
    <Group>
      <Input {...otherProps} />
      {label && (
        <FormInputLabel
          shrink={Boolean(
            otherProps &&
              typeof otherProps.value == 'string' &&
              otherProps.value.length
          )}>
          {label}
        </FormInputLabel>
      )}
    </Group>
  )
}

export default FormInput
